export interface StockItemTransaction {
  id: string;
  stockItemId: string;
  transactionDate: Date;
  transactionNumber: number;
  transactionType: string;
  transactionQty: number;
  balance: number;
  stockAdjustmentReason: string;
  productKey: string;
  productDescription: string;
  pricePerUnit: string;
  location: string;
  batchNo: string;
  grade: string;
  customer: string;
  stockNo: string;
  makeUp: string;
  user: string;
  comments: string;
  documentDate: Date;
  transactionSequence: number;
}
